class IntersectionHandler extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['observable', 'video', 'content']
  }

  static get observedAttributes () {
    return ['threshold']
  }

  connectedCallback () {
    super.connectedCallback()

    this.videoPlaying = false

    // eslint-disable-next-line compat/compat
    this.observer = new IntersectionObserver(
      this.intersectionObserverCallback.bind(this),
      {
        threshold: this.threshold,
      },
    )

    this.els?.observable?.elements?.forEach(observableEl =>
      this.observer.observe(observableEl),
    )
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    this.observer.unobserve(this)
  }

  intersectionObserverCallback (entries) {
    if (!entries?.length) return

    entries.forEach(entry => {
      if (this.videoPlaying) return

      if (entry.isIntersecting) {
        this.videoPlaying = true

        this.els?.video?.element?.addEventListener(
          'loadeddata',
          this.setVideo(),
        )
      }
    })
  }

  setVideo () {
    if (this.els?.content?.element) {
      setTimeout(() => {
        this.els?.content?.element.classList.add(
          'sec-IntersectionVideo_ContentContainer-show',
        )
      }, this.els?.content?.element.dataset.timeout)
    }

    this.els?.video?.element?.play()
  }

  get threshold () {
    return this.hasAttribute('threshold')
      ? Number(this.getAttribute('threshold'))
      : 0
  }
}

if (!customElements.get('intersection-video-handler')) {
  customElements.define('intersection-video-handler', IntersectionHandler)
}
